export default __webpack_public_path__ + "static/media/leftArrowCircle.0c44fb10.svg";